<template>
  <donut-errors-base :code-chars="[5, 0]">
    <div class="m-tx1">
      <div class="t-lg">Looks like we broke something...</div>
      <div class="t-lg">Don't worry, our best people are on it.</div>
    </div>
  </donut-errors-base>
</template>
